import {
    doesStringHaveSpecialChars, isNumeric, containsAlphaNumAndSpaceOnly, isValidDate
} from "../../util/Validators";
import _ from "lodash";

export const validateInput = (name, value) => {
    let hasError = false,
        error = "";
    switch (name) {
        case "amount":
            {
                if (value === "") {
                    hasError = true;
                    error = "Amount cannot be empty";
                } else if (!isNumeric(value)) {
                    hasError = true;
                    error = "Please enter a valid amount";
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            }
        case "quantity":
            {
                if (value === "") {
                    hasError = true;
                    error = "Quantity cannot be empty";
                } else if (!isNumeric(value)) {
                    hasError = true;
                    error = "Please enter a valid quantity";
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            }
        case "description":
            if ((value !== null && value !== undefined) && value.trim() === "") {
                hasError = true;
                error = "Description cannot be empty";
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true;
                error = "Description can only have alpha-numeric characters";

            } else if (doesStringHaveSpecialChars(value)) {
                hasError = true;
                error = "Description can only have alpha-numeric characters";

            } else {
                hasError = false;
                error = "";
            }
            break;
        case "dueDate":
            if (value.trim() === "" || !isValidDate(value)) {
                hasError = true;
                error = "Due date cannot be empty";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "billDate":
            if (value.trim() === "" || !isValidDate(value)) {
                hasError = true;
                error = "Bill date is invalid";
            } else {
                hasError = false;
                error = "";
            }
            break;

        case "accountId":
            if (value.trim() === "") {
                hasError = true;
                error = "Account cannot be empty";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "lineItems":
            let lineItems = value;
            if (_.isEmpty(lineItems)) {
                hasError = true;
                error = "The bill must have atleast one line item";
            }
            for (let li of lineItems) {
                if (li.lineItemDescription.trim() === "") {
                    hasError = true;
                    error = error + "Line Item Description is required. ";
                } else if (!containsAlphaNumAndSpaceOnly(li.lineItemDescription)) {
                    hasError = true;
                    error = error + "Line Item Descrption can contain only alpha-numeric characters. ";
                } else if (doesStringHaveSpecialChars(li.lineItemDescription)) {
                    hasError = true;
                    error = error + "Line Item Descrption can contain only alpha-numeric characters. ";
                }
                if (!li.lineItemAmount) {
                    hasError = true;
                    error = error + "Line Item Amount is required";

                } else if (!isNumeric(li.lineItemAmount)) {
                    hasError = true;
                    error = error + "Line Item Amount is invalid";
                }
                if (!li.quantity) {
                    hasError = true;
                    error = error + "Line Item Quantity is required";

                } else if (!isNumeric(li.quantity)) {
                    hasError = true;
                    error = error + "Line Item Quantity is invalid";
                }
            }
            break;
        case "keyword":
            if (!value || value.trim() === "") {
                hasError = false;
                error = "";
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true;
                error = "Keyword can only have alpha-numeric characters";

            } else if (doesStringHaveSpecialChars(value)) {
                hasError = true;
                error = "Keyword can only have alpha-numeric characters";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "fromBillDate":
            if (!value || value.trim() === "") {
                hasError = false;
                error = "";
            } else if (!isValidDate(value)) {
                hasError = true;
                error = "From Bill date is invalid";
            } else {
                hasError = false;
                error = "";
            }
            break;
        case "toBillDate":
            if (!value || value.trim() === "") {
                hasError = false;
                error = "";
            } else if (!isValidDate(value)) {
                hasError = true;
                error = "To Bill date is invalid";
            } else {
                hasError = false;
                error = "";
            }
            break;
        default:
            break
    }
    return { hasError, error }
}